import type * as ecModels from '../../../models'

import * as models from './models'
import type { Plugin } from './plugin'
/*  eslint-disable */
export class Selectors<TTypeParams extends ecModels.TypeParams.Constraint> {
  private readonly _lookup
  // NOTE: intentionally not typed here so that type can be inferred
  private readonly _groups
  // NOTE: intentionally not typed here so that type can be inferred
  public readonly getGroups
  // NOTE: intentionally not typed here so that type can be inferred
  public readonly getGroupsWithEntityIds
  // NOTE: intentionally not typed here so that type can be inferred
  public readonly getGroupWithEntities
  // NOTE: intentionally not typed here so that type can be inferred
  public readonly getGroupsWithEntities

  constructor(plugin: Plugin<TTypeParams>) {
    this._lookup = plugin.feature.state.project(state => state.groups)
    this._groups = this._lookup.project(groups => Object.values(groups))
    this.getGroups = plugin.feature.createSelectorMethod(
      (selection?: models.GroupSelection<TTypeParams>) =>
        selection
          ? this._groups.project(groups =>
              groups.filter(group =>
                models.GroupSelection.normalize(selection).includes(group.id),
              ),
            ).asSelector
          : this._groups.asSelector,
    )

    this.getGroupsWithEntityIds = plugin.feature.createSelectorMethod(
      (selection?: models.GroupSelection<TTypeParams>) =>
        this.getGroups(selection).project(
          plugin.collection.plugins.currentListPlugin.feature.selectors.ids
            .asSelector,
          plugin.collection.plugins.cachePlugin.feature.selectors.lookup
            .asSelector,
          (groups, currentIds, entityLookup) =>
            groups.map<models.Group.WithEntityIds<TTypeParams>>(group => ({
              ...group,
              entityIds: group.entitySelector.ids
                ? // Uses the groups associated IDs
                  group.entitySelector.ids
                : // Filters the current list with the given predicate
                  currentIds.filter(id => {
                    if (!group.entitySelector.predicate) {
                      // No predicate = no filtering
                      return true
                    }
                    const entity = entityLookup[id]
                    if (!entity) {
                      // No entity = excluded
                      return false
                    }
                    // Otherwise, use given predicate
                    return group.entitySelector.predicate(entity)
                  }),
            })),
        ).asSelector,
    )

    this.getGroupWithEntities = plugin.feature.createSelectorMethod(
      (groupId: string) =>
        this.getGroupsWithEntityIds({ groupId }).project(
          plugin.collection.plugins.cachePlugin.feature.selectors.lookup
            .asSelector,
          (groups, entityLookup) => {
            const group = groups.find(g => g.id === groupId)
            if (!group) {
              return undefined
            }
            const groupWithEntities: models.Group.WithEntities<TTypeParams> = {
              ...group,
              entities: group.entityIds.map(id => entityLookup[id]),
            }
            return groupWithEntities
          },
        ).asSelector,
    )

    this.getGroupsWithEntities = plugin.feature.createSelectorMethod(
      (selection?: models.GroupSelection<TTypeParams>) =>
        this.getGroupsWithEntityIds(selection).project(
          plugin.collection.plugins.cachePlugin.feature.selectors.lookup
            .asSelector,
          (groups, entityLookup) =>
            groups.map<models.Group.WithEntities<TTypeParams>>(group => ({
              ...group,
              // TODO: Figure out what to do with undefined/missing entities. We
              // could filter them out or we could leave them undefined, or we
              // could have some way of creating a default entity, with just the
              // id
              entities: group.entityIds.map(id => entityLookup[id]),
            })),
        ).asSelector,
    )
  }
}
